import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import _ from 'lodash';
import { rgba } from 'polished';
import { withCalculator } from '@deerplusofficial/pos-hoc';
import { ButtonBase } from '@deerplusofficial/pos-components';
import { color } from '@deerplusofficial/pos-helper';
import Info from '../Info/Info';

const ManuallyInputWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

const ManuallyInput = styled.input.attrs({ type: 'text' })`
  cursor: pointer;
  border: 0;
  line-height: 1.4;
  text-align: ${props => (props.hasControllers ? 'center' : 'right')};
  &:focus {
    background-color: ${rgba(color.border, 0.5)};
  }
`;

const QuantityButton = styled(ButtonBase)`
  padding: 0 0.5em;
  ${props =>
    props.alignRight &&
    css`
      padding-right: 0;
    `};
`;

class InfoWithCalculator extends PureComponent {
  static propTypes = {
    onKeyDown: PropTypes.func,
    onFocus: PropTypes.func,
    onChange: PropTypes.func,
    onAddonClick: PropTypes.func,
    addon: PropTypes.oneOf(['delete', false]),
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.string,
    autoFocus: PropTypes.bool,
    hasControllers: PropTypes.bool,
    calculatorMode: PropTypes.oneOf(['auto', 'amount', 'keyboard']),
  };

  static defaultProps = {
    onKeyDown: _.identity,
    onFocus: _.identity,
    onChange: _.identity,
    onAddonClick: _.identity,
    addon: false,
    value: '',
    label: '',
    autoFocus: false,
    hasControllers: false,
    calculatorMode: 'auto',
  };

  onMinusClick = () => {
    const { value, onChange } = this.props;

    if (value <= 1) return;

    onChange(value - 1);
  };

  onPlusClick = () => {
    const { value, onChange } = this.props;

    onChange(value + 1);
  };

  render() {
    const {
      label,
      value,
      autoFocus,
      addon,
      hasControllers,
      onKeyDown,
      onFocus,
      onAddonClick,
    } = this.props;

    return (
      <Info label={label} addon={addon} onAddonClick={onAddonClick}>
        <ManuallyInputWrapper>
          {hasControllers && (
            <QuantityButton onClick={this.onMinusClick}>-</QuantityButton>
          )}
          <ManuallyInput
            readOnly
            hasControllers={hasControllers}
            autoFocus={autoFocus}
            onKeyDown={onKeyDown}
            onFocus={onFocus}
            value={value}
            size={_.size(String(value)) + 1}
          />
          {hasControllers && (
            <QuantityButton alignRight onClick={this.onPlusClick}>
              +
            </QuantityButton>
          )}
        </ManuallyInputWrapper>
      </Info>
    );
  }
}

export default withCalculator()(InfoWithCalculator);



// WEBPACK FOOTER //
// ./src/components/InfoWithCalculatorInput/InfoWithCalculatorInput.js